import dbService from './dbService';

let cachedPermissions = null; // In-memory cache

// Helper to transform the DB array into a fast lookup map
const transformToMap = (permissionsArray) => {
    const map = {};
    for (const item of permissionsArray) {
        map[item.role] = item.permissions;
    }
    return map;
};

const permissionService = {
    // The core function is now async
    can: async (user, requiredPermission) => {
        if (!user || !user.role) return false;

        // Step 1: Check if permissions are already cached
        if (!cachedPermissions) {
            // Step 2: If not, fetch them from IndexedDB
            const permissionsFromDB = await dbService.getAll('permissions');
            // Step 3: Transform and store them in the cache
            cachedPermissions = transformToMap(permissionsFromDB);
        }

        const userPermissions = cachedPermissions[user.role];
        if (!userPermissions) return false;

        return userPermissions[requiredPermission] || false;
    },

    // A function to clear the cache after we save new permissions
    clearCache: () => {
        cachedPermissions = null;
    }
};

export default permissionService;